module.exports = __webpack_public_path__ + "image/google.562d4d49.jpg";